
import { EnterpriseService } from '@/services'
import { Component, Vue } from 'vue-property-decorator'
import CompanyDetailForm from '../components/company_detail_form.vue'

@Component({
    name: 'info-edit-detail',
    components: {
        CompanyDetailForm
    }
})
export default class extends Vue {
    private isLoading = true
    private changeLoading = false
    private statusOption = {
        Ing: 1,
        Pass: 2,
        Fail: 3
    }
    private companyId = ''
    private company = { 
        name: '',
        company: { name: '' },
        user: { id: ''  },
        status: 0
    }

    private created() {
        this.$title('Loading | 机构修改信息详情 - 庖丁')
        this.companyId = this.$route.params.id
    }

    private async mounted() {
        this.isLoading = true
        await this.getDetail()
        this.isLoading = false
    }

    get matchStatus() {
        const { statusOption } = this
        const status = {
            [statusOption.Ing]: '审核中',
            [statusOption.Pass]: '审核通过',
            [statusOption.Fail]: '审核不通过'
        }
        return Reflect.get(status, this.company.status)
    }

    private matchButtonType(status: number) {
        return this.company.status === status ? 'primary' : 'default'
    }

    /** 修改申请的信息 */
    private async getDetail() {
        try {
            const params = {
                id: +this.companyId
            }
            const result = await EnterpriseService.getEditInfoDetail(params)
            console.log('机构修改信息详情接口返回:', result)
            if (result && result.status === 200 && result.data) {
                const data = result.data
                this.company = {
                    ...data,
                    company: data.company || {},
                    user: data.user || {},
                    status: data.status !== undefined ? data.status : 0,
                    created_at: data.createdAt || data.created_at || '',
                    updated_at: data.updatedAt || data.updated_at || ''
                }
                const companyName = data.company && data.company.name ? data.company.name : '机构'
                this.$title(`${companyName} | 机构修改信息详情 - 庖丁`)
            } else {
                console.error('接口返回数据不符合预期:', result)
            }
        } catch (e) {
            console.error('获取机构修改信息详情失败:', e)
        }
    }

    // 改变状态
    private async changeStatus(status: number) {
        if (this.company.status === status) return
        this.changeLoading = true
        const params = {
            id: +this.companyId,
            status
        }
        const result = await EnterpriseService.updateEditInfoStatus(params)
        this.changeLoading = false
        if (result.status === 200) {
            this.company.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }
}
